import script from "./BssMovementConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMovementConfig.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__